var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"inst__icon",class:{ active: _vm.active }},[_c('img',{attrs:{"src":_vm.iconPath}})]),_c('span',{staticClass:"inst__itemname"},[_vm._v(" "+_vm._s(_vm.skill.name[_vm.$i18n.locale])+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }